import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { Button, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import useStyles from './styles';

/** Mirrors PropertyUtilityAccount.AccountNumberMaxLength on the server. */
const ACCOUNT_NUMBER_MAX_LENGTH = 64;

/**
 * Add or edit one utility account number.
 *
 * Kept as its own component, declared at module level, because an inline component would be a new
 * type on every parent render and would remount — losing focus mid-typing.
 */
export const UtilityAccountForm = _ref => {
  let initialValue = _ref.initialValue,
    isSaving = _ref.isSaving,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel;
  const classes = useStyles();
  const _useState = useState({
      accountNumber: (initialValue === null || initialValue === void 0 ? void 0 : initialValue.accountNumber) || '',
      serviceType: (initialValue === null || initialValue === void 0 ? void 0 : initialValue.serviceType) || '',
      isDefaultForAccountNumber: (initialValue === null || initialValue === void 0 ? void 0 : initialValue.isDefaultForAccountNumber) || false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  const handleChange = field => event => setState(previous => _objectSpread(_objectSpread({}, previous), {}, {
    [field]: event.target.value
  }));
  const handleSubmit = event => {
    event.preventDefault();
    onSubmit({
      accountNumber: state.accountNumber.trim(),
      serviceType: state.serviceType.trim() || null,
      isDefaultForAccountNumber: state.isDefaultForAccountNumber
    });
  };
  const canSave = state.accountNumber.trim().length > 0 && !isSaving;
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formRow
  }, /*#__PURE__*/React.createElement(TextField, {
    className: classes.field,
    label: "Account number",
    placeholder: "As printed on the bill",
    value: state.accountNumber,
    onChange: handleChange('accountNumber'),
    helperText: "Spaces and dashes don't matter \u2014 we match on the digits and letters."
    // 64 is the server's limit; stopping here beats a round trip that fails validation.
    ,
    inputProps: {
      maxLength: ACCOUNT_NUMBER_MAX_LENGTH
    },
    autoFocus: true,
    required: true,
    disabled: isSaving
  }), /*#__PURE__*/React.createElement(TextField, {
    className: classes.field,
    label: "Service (optional)",
    placeholder: "Water, Electric\u2026",
    value: state.serviceType,
    onChange: handleChange('serviceType'),
    helperText: "Leave blank if this number covers every service. \u201CElectric\u201D matches a bill printed \u201CElectric Service\u201D.",
    disabled: isSaving
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: state.isDefaultForAccountNumber,
      onChange: event => setState(previous => _objectSpread(_objectSpread({}, previous), {}, {
        isDefaultForAccountNumber: event.target.checked
      })),
      disabled: isSaving
    }),
    label: "Use this property when the number covers several properties"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light",
    className: classes.defaultHint
  }, "Only matters for a shared or master account. Without it, a bill quoting a number that belongs to several properties goes to review instead of attaching.")), /*#__PURE__*/React.createElement("div", {
    className: classes.formRow
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    type: "submit",
    disabled: !canSave
  }, isSaving ? 'Saving…' : 'Save'), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: onCancel,
    disabled: isSaving
  }, "Cancel")));
};